<template>
	<div class="text-widget">
		<IntercomLauncher launcher-text="Text Us!" @close="reset()">
			<template #launcher-close>
				<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="#fff" viewBox="0 0 384 512"><path d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"/></svg>

			</template>

			<template #launcher-open>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#fff"><path d="M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"/></svg>
			</template>

			<template #header>
				<div class="flex items-center gap-x-4">
					<div class="px-4 flex-initial">
						<i class="fas fa-2x fa-message"></i>
					</div>
					<div class="text-xl flex-auto">Send us a text</div>
				</div>
			</template>

			<AppForm
				ref="widgetFormRef"
				:value="data"
				name="text-widget-form"
				id="textWidgetForm"
				class="flex flex-col p-8"
				action="/contact/text-us"
				v-slot="{ status, errorBag, model }">

				<TextInput
							id="nameinput"
							name="name"
							required
							autofocus
							v-model="model.name"
							label="Your Name" />

				<PhoneInput
							id="phoneinput"
							name="phone"
							required
							rules="phone"
							v-model="model.phone"
							label="Phone Number" />

				<TextInput
							id="emailinput"
							name="email"
							required
							rules="email"
							v-model="model.email"
							label="Email Address" />

				<FormTextarea
								inputClass="resize-none"
								id="messageinput"
								rows="4"
								max-rows="5"
								name="message"
								required
								v-model="model.message"
								label="Your Message"
								no-resize />

				<AppOptins small v-model="model.optins" />

				<div class="mb-4 text-center">
					<div class="text-center mb-8" v-if="errorBag?.message">
						<span class="text-red-600">{{ errorBag.message }}</span>
					</div>

					<div v-if="status === 'sent'" class="font-bold text-green-400" v-cloak>Message Sent!</div>
				</div>

				<AppButton
							:loading="status === 'sending'"
							:disabled="status && ['sending', 'sent'].includes(status)"
							type="submit"
							block>Send Text
				</AppButton>
			</AppForm>

		</IntercomLauncher>
	</div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from "vue";
import IntercomLauncher from "./Intercom/Launcher.vue";
import { AxiosError } from "axios";
import AppButton from "./AppButton.vue";
import { AppForm, FormTextarea } from "./Forms";
import PhoneInput from "./Forms/custom/PhoneInput.vue";
import TextInput from "./Forms/TextInput.vue";
import AppOptins from "./Forms/custom/Optins.vue";
import ApiService from "@/services/ApiService";
import { ResourceResponse } from "@/core/http-client";


export default defineComponent({
	name: "TextWidget",
	components: {
		IntercomLauncher,
		AppButton,
		AppForm,
		PhoneInput,
		TextInput,
		AppOptins,
		FormTextarea
	},
	setup() {
		const widgetFormRef = ref<InstanceType<typeof AppForm>>();
		const data = {
			name: null,
			phone: null,
			email: null,
			message: null,
			optins: {
				email: true,
				sms: true,
			}
		}

		const { status, value: form } = widgetFormRef.value || {};

		const sending = computed(() => status === 'sending');
		const submitted = computed(() => status === 'sent')

		const reset = () => {
			widgetFormRef.value?.reset();
		}

		return { reset, sending, submitted, data, widgetFormRef };
	}
});
</script>

<style lang="scss">
body.shelf-showing .ic-launcher-wrapper {
	bottom: 110px;
}

body.shelf-showing .ic-window {
	max-height: calc(100vh - 220px);
	bottom: 200px;
}
</style>
